import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {Subscription} from "rxjs";
import {ToastService} from "../../services/toast.service";

@Component({
    selector: 'kaz-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ToastComponent implements OnInit, OnDestroy{
  private _toast = inject(ToastService);

  title: string | null = null;
  description: string | null = null;
  show: boolean = false;

  private toastSubscription: Subscription | null = null;

  ngOnInit() {
    this.toastSubscription = this._toast.toastState$.subscribe(data =>{
      this.title = data.title;
      this.description = data.description;
      this.show = true;
      console.log("Toast erhalten:", data); // Debug-Ausgabe

      setTimeout(()=> this.show = false, 3000);
    })
  }

  ngOnDestroy() {
    this.toastSubscription?.unsubscribe();
  }
}
